import { Box, Typography } from '@mui/material'
import { FC, ReactNode } from 'react'

interface LoginTitleProps {
    children: ReactNode
}

export const LoginTitle: FC<LoginTitleProps> = ({ children }) => <Box sx={{ textAlign: 'center' }}>
    <Typography variant="h2" component="h1">
        {children}
    </Typography>
</Box>
